import React from 'react';
import { useTranslation } from 'react-i18next';
import { CellContext } from '@tanstack/react-table';
import { DeviceDashboardTableData } from '@/types/operational-ui.types';
// import { formatRelativeTime } from '@/utils/operational-ui.utils';
import { formatDateAsYearMonthDayHourMinute } from '@/utils/formatters/dateFormatter';

export const DeviceDashboardLastOperationCell = (
  info: CellContext<DeviceDashboardTableData, any>
) => {
  const { t } = useTranslation();
  const lastOperationTimestamp = info.getValue() as string;

  if (!lastOperationTimestamp) {
    return (
      <span className="text-gray-500 text-sm italic">
        {t('pages.operations.devices.lastActivity.never')}
      </span>
    );
  }

  const tz = info.row.original.lastOperationTz ?? 'UTC';
  const relativeTime = formatDateAsYearMonthDayHourMinute(lastOperationTimestamp, tz);

  // Determine color based on recency
  const getTimeColor = (timestamp: string) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const hoursDiff = (now.getTime() - activityTime.getTime()) / (1000 * 60 * 60);

    if (hoursDiff < 1) return 'text-green-600'; // Less than 1 hour - fresh
    if (hoursDiff < 24) return 'text-blue-600'; // Less than 24 hours - recent
    if (hoursDiff < 168) return 'text-yellow-600'; // Less than 1 week - moderate
    return 'text-red-600'; // Older than 1 week - stale
  };

  return (
    <span className={`text-sm font-medium ${getTimeColor(lastOperationTimestamp)}`}>
      {relativeTime}
    </span>
  );
};
